<template>
  <div class="latest-news-fi">
    <template
      v-for="(news, index) in latestPressNews"
      :key="index"
    >
      <SubRenderingProvider
        :fields="news"
        :data-source="news.id"
      >
        <teaser-tile-fi theme="newsroom" />
      </SubRenderingProvider>
    </template>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, onServerPrefetch, ref } from 'vue';

import SubRenderingProvider from '@/components/atoms/multi-data-source-provider-fi/SubRenderingProvider.vue';
import { useFischer } from '@/composables/fischerPlugin';

const TeaserTileFi = defineAsyncComponent(() => import('@/pages/teaser-tile-fi/TeaserTileFi.vue'));

defineOptions({ name: 'LatestNewsFi' });

const fischer = useFischer();

const latestPressNews = ref<any[]>([]);

async function getPressNews() {
  const pressReleasesUrl = IS_SHOWROOM
    ? '/__mocks__/newsroom/newsroom-overview.json'
    : `${fischer.hostUrlBase()}/api/press/get?lang=${fischer.siteLanguage()}&pagesize=3`;

  const pressResponse = await fetch(pressReleasesUrl);
  if (!pressResponse.ok) throw new Error(`Could not fetch news: ${pressResponse.status}`);
  const pressResult = await pressResponse.json();

  const getLocalDate = (date: string) =>
    date
      ? new Date(date).toLocaleDateString(fischer.siteLanguage(), {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      : '';

  latestPressNews.value = pressResult?.Data?.PressReleasesList?.map((n: any) => ({
    headline: { value: n.Document.TeaserHeadline },
    date: { value: getLocalDate(n.Document.Date) },
    paragraph: { value: n.Document.TeaserText },
    image: {
      value: {
        src: n.Document.TeaserImage,
      },
    },
    link: {
      value: {
        href: n.Document.ItemLink,
        url: n.Document.ItemLink,
      },
    },
    lang: { value: n.Document.Language },
    id: '', // TODO backend needs to privide this
  }));
}

onServerPrefetch(() => {
  getPressNews();
});

onMounted(() => {
  getPressNews();
});
</script>

<style scoped src="./latest-news-fi" />
